module.exports = __webpack_public_path__ + "02_long_beige.fa9b4471.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_long_beige.png
// module id = r3/Y
// module chunks = 0